import { getByPostalCode } from '../api/Shops';
import MasoutisAlertStore from '../store/masoutisAlert';

export async function checkPostalCodeForMasoutis(postalCode, onChangeAddress, changeLabel) {
  if (!postalCode) return false;

  try {
    const { redirectToMasoutis } = await getByPostalCode(postalCode);

    if (redirectToMasoutis) {
      MasoutisAlertStore.open(onChangeAddress, changeLabel);
      return true;
    }
  } catch {
    // fail silently — don't block the user journey on a check error
  }

  return false;
}
